import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { formatPhone } from '@/lib/utils/formatters'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, makeLink } from '../../utils/configuredReportFormatters'

export const missingContactsColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) =>
      row.property_id
        ? makeLink(
            `/property/edit/${row.property_id}`,
            display(row.property_name),
            true,
          )
        : display(row.property_name),
  },
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) =>
      row.company_id
        ? makeLink(
            `/company/edit/${row.company_id}`,
            display(row.company_name),
            true,
          )
        : display(row.company_name),
  },
  {
    id: 'team_name',
    label: 'Sales Team',
    sortKey: 'team_name',
    render: (row) => display(row.team_name ?? row.teamname),
  },
  {
    id: 'regional_manager',
    label: 'Regional Manager',
    render: (row) => display(row.regional_manager),
  },
  {
    id: 'property_manager',
    label: 'Property Manager',
    render: (row) => display(row.property_manager),
  },
  {
    id: 'property_assistant',
    label: 'Property Assistant',
    render: (row) => display(row.property_assistant),
  },
  {
    id: 'leasing_consultant',
    label: 'Leasing Consultant',
    render: (row) => display(row.leasing_consultant),
  },
  {
    id: 'phone',
    label: 'Phone',
    render: (row) =>
      formatPhone(String(row.property_phone ?? row.company_phone ?? '')) || '—',
  },
  {
    id: 'listed',
    label: 'Liberty Listed',
    sortKey: 'listed',
    render: (row) =>
      String(row.listed ?? '') === '1' ? 'Active' : 'Not Active',
  },
]
